import React from "react";
import { Button } from "@material-ui/core";
import DataTable from "@/components/DataTable";
import { ReactRender } from "@/components/ReactRender";
import { useTranslation } from "@/langs/useTranslation";

export const SelectedAlarmTemplateDatatable = React.forwardRef(
  (
    { className, style, data, templateId, children, onLoaded, onDelete },
    ref
  ) => {
    const { t } = useTranslation();

    const columns = [
      {
        data: "name",
        title: t({ defaultMessage: "报警模板名称" }),
        width: 450,
        searchable: true
      },
      {
        data: "policies",
        title: t({ defaultMessage: "报警规则" }),
        searchable: true,
        createdCell: (td, data, row) => {
          ReactRender(
            <>
              {data.map((item, index) => (
                <div key={index}>
                  {item.replace("&lt;", " < ").replace("&gt;", " > ")}
                </div>
              ))}
            </>,
            td
          );
        }
      },
      {
        data: null,
        title: t({ defaultMessage: "操作" }),
        width: 100,
        className: "center",
        createdCell: (td, data, row) => {
          ReactRender(
            <Button
              size="small"
              color="secondary"
              onClick={() => onDelete(row)}
            >
              {t({ defaultMessage: "删除" })}
            </Button>,
            td
          );
        }
      }
    ];

    // const ajax = (data, callback, settings) => {
    //   return getAlarmTemplateDevicesApi({
    //     alarm_template_id: templateId,
    //     page: data.page,
    //     pageSize: data.pageSize
    //   }).then(res => {
    //     callback({
    //       data: res.data,
    //       draw: data.draw,
    //       recordsFiltered: res.recordsTotal,
    //       recordsTotal: res.recordsTotal
    //     });
    //   });
    // };

    return (
      <DataTable
        ref={ref}
        options={{ serverSide: false, paging: false }}
        columns={columns}
        data={data}
        // ajax={ajax}
        className={className}
        style={style}
        autoLoad
        showFooter={false}
        onLoaded={onLoaded}
      >
        {children}
      </DataTable>
    );
  }
);
